import React from 'react';
import styles from './LegalModal.module.css';

interface PrivacyPolicyProps {
  onClose: () => void;
}

const PrivacyPolicy: React.FC<PrivacyPolicyProps> = ({ onClose }) => {
  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <button className={styles.closeButton} onClick={onClose} aria-label="Close">
          <i className="fas fa-times" />
        </button>
        
        <div className={styles.modalBody}>
          <h1>Privacy Policy</h1>
          <p className={styles.lastUpdated}><strong>Last Updated:</strong> January 9, 2025</p>

          <h2>Introduction</h2>
          <p>
            Dan White Web Solutions ("we", "us", "our") operates danwhitewebsolutions.com. 
            This Privacy Policy explains how we collect, use, disclose, and protect your personal 
            information when you use our website and services.
          </p>
          <p>
            We are committed to protecting your privacy and complying with the Australian Privacy 
            Principles under the Privacy Act 1988 (Cth).
          </p>

          <h2>Information We Collect</h2>
          <h3>Personal Information</h3>
          <p>When you contact us through our website, we collect:</p>
          <ul>
            <li>Name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Any information you provide in your message or inquiry</li>
          </ul>

          <h3>Automatically Collected Information</h3>
          <p>We may collect:</p>
          <ul>
            <li>IP address</li>
            <li>Browser type and version</li>
            <li>Pages visited and time spent on our website</li>
            <li>Referring website addresses</li>
          </ul>

          <h2>How We Use Your Information</h2>
          <p>We use your personal information to:</p>
          <ul>
            <li>Respond to your inquiries and provide customer support</li>
            <li>Provide web design services you have requested</li>
            <li>Send project updates and communications</li>
            <li>Improve our website and services</li>
            <li>Comply with legal obligations</li>
          </ul>

          <h2>How We Store Your Information</h2>
          <p>
            Your information is stored securely using industry-standard security measures. Contact 
            form submissions are processed through Formspree and delivered to our business email 
            (danwhitewebsolutions@outlook.com). We retain your information only as long as necessary 
            to provide services or as required by law.
          </p>

          <h2>Disclosure of Your Information</h2>
          <p>
            We do not sell, trade, or rent your personal information to third parties. We may share 
            information with:
          </p>
          <ul>
            <li>Service providers who assist us (e.g., email services, hosting providers)</li>
            <li>Legal authorities if required by law</li>
          </ul>

          <h2>Your Rights</h2>
          <p>Under Australian privacy law, you have the right to:</p>
          <ul>
            <li>Access your personal information</li>
            <li>Correct inaccurate information</li>
            <li>Request deletion of your information (subject to legal requirements)</li>
            <li>Opt-out of marketing communications</li>
          </ul>

          <h2>Cookies</h2>
          <p>
            We may use cookies to improve your experience on our website. You can control cookie 
            settings through your browser preferences.
          </p>

          <h2>Third-Party Links</h2>
          <p>
            Our website may contain links to third-party websites. We are not responsible for their 
            privacy practices.
          </p>

          <h2>Contact Us</h2>
          <p>
            If you have questions about this Privacy Policy or wish to exercise your privacy rights, 
            contact us at:
          </p>
          <div className={styles.contactBox}>
            <p><strong>Dan White Web Solutions</strong></p>
            <p>Email: danwhitewebsolutions@outlook.com</p>
            <p>Phone: 0432 430 287</p>
            <p>Address: 14 Sky Place, Bellingen NSW 2454</p>
          </div>

          <h2>Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Changes will be posted on this page 
            with an updated revision date.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;